/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoicesContainer_viewer$ref: FragmentReference;
export type InvoicesContainer_viewer = {|
  +past_due_payments_cents: ?number,
  +outstanding_payments_cents: ?number,
  +$refType: InvoicesContainer_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "InvoicesContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "past_due_payments_cents",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "outstanding_payments_cents",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '3b9d0fffc287fd75df9a74eb2434925b';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Financial/Invoices/__generated__/InvoicesContainer_viewer.graphql.js